module.exports = __webpack_public_path__ + "img/search.5578feb3.svg";